export const employments = [
    {
        'company': 'KONE',
        'time': 'May 2024 - May 2025',
        'positions': [
            {
                'title': 'Data Engineer Intern',
                'time': 'May 2024 - December 2024',
                'achievements': (
                    <ul>
                        <li>
                            <p><span>Technologies:</span> TypeScript, Python, SQL, Terraform, AWS, Databricks Unity Catalog, dbt, Docker, Spark.</p>
                        </li>
                        <li>
                            <p>Built reusable cross-environment Terraform modules, efficiently provisioning cloud resources including AWS Glue tables, Unity Catalog schemas, Databricks tables, and access grants.</p>
                        </li>
                        <li>
                            <p>Maintained and debugged existing AWS Glue ETL scripts in PySpark, ensuring cost-effective performance and reliable data quality in production environment.</p>
                        </li>
                        <li>
                            <p>Provisioned new AWS IAM resources and improved current S3 configurations using AWS CDK, leveraging fine-grained access control and optimizing storage costs.</p>
                        </li>
                        <li>
                            <p>Developed and containerized dbt models into Docker images, orchestrated their scheduled executions with AWS Batch jobs, producing Delta Lake tables used for business intelligence.</p>
                        </li>
                        <li>
                            <p>Designed and implemented GitLab CI/CD pipelines, automating the releases of IaC updates within data workflows.</p>
                        </li>
                    </ul>
                )
            },
        ]
    },
    {
        'company': 'Slush',
        'time': 'Sep 2023 - Dec 2023',
        'positions': [
            {
                'title': 'Junior Software Engineer',
                'time': 'Sep 2023 - Dec 2023',
                'achievements': (
                    <ul>
                        <li>
                            <p><span>Technologies:</span> TypeScript, PostgreSQL, Express, React, React Native, Node, Google Cloud Platform, Docker.</p>
                        </li>
                        <li>
                            <p>Developed an in-house lunch matching app to replace third-party service, saving $5,000 annually.</p>
                        </li>
                        <li>
                            <p>Reduced the lunch matching algorithm's time complexity from O(n<sup>3</sup>) to O(n &middot; log(n)) and space complexity from O(n<sup>2</sup>) to O(n)</p>
                        </li>
                        <li>
                            <p>Built full-stack features with PERN stack for the administrative system used to monitor all organisation events.</p>
                        </li>
                        <li>
                            <p>Implemented key front-end components in the Slush website and mobile app, serving 40,000 users.</p>
                        </li>
                        <li>
                            <p>Enhanced the meetings booking feature on the mobile app, decreasing front-end latency by 3 seconds.</p>
                        </li>
                    </ul>
                )
            }
        ]
    },
    {
        'company': 'ABB',
        'time': 'Jan 2023 - Aug 2023',
        'positions': [
            {
                'title': 'Data Analyst Intern',
                'time': 'Jan 2023 - Aug 2023',
                'achievements': (
                    <ul>
                        <li>
                            <p><span>Technologies:</span> Python, SQL, Azure, Databricks, Power BI, scikit-learn, Spark.</p>
                        </li>
                        <li>
                            <p>Created PySpark analytics functions to extract quality metrics from IoT data and visualized insights through Power BI reports, enabling daily monitoring of production data health.</p>
                        </li>
                        <li>
                            <p>Developed IO libraries within Databricks environments, streamlining the processes of reading from and writing to Azure Data Lake for the data science team</p>
                        </li>
                        <li>
                            <p>Implemented an ensemble regression model with scikit-learn, predicting data storage costs with high accuracy.</p>
                        </li>
                    </ul>
                )
            }
        ]
    },
    {
        'company': 'Elisa',
        'time': 'May 2022 - Aug 2022',
        'positions': [
            {
                'title': 'Software Engineer Intern',
                'time': 'May 2022 - Aug 2022',
                'achievements': (
                    <ul>
                        <li>
                            <p><span>Technologies:</span> Python, SQL, Azure, Databricks, sciki-learn, Spark, TensorFlow.</p>
                        </li>
                        <li>
                            <p>Migrated users data from a legacy information model to a refined schema, significantly enhancing accessibility.</p>
                        </li>
                        <li>
                            <p>Built out-of-the-box data processing functionalities with Spark for various machine learning workflows.</p>
                        </li>
                        <li>
                            <p>Developed automated machine learning solutions to accelerate the models and parameters selection process.</p>
                        </li>
                    </ul>
                )
            }
        ]
    },
    {
        'company': 'Futurice',
        'time': 'Jan 2022 - Apr 2022',
        'positions': [
            {
                'title': 'Software Engineer Intern',
                'time': 'May 2022 - Aug 2022',
                'achievements': (
                    <ul>
                        <li>
                            <p><span>Technologies:</span> Python, pytest, AWS S3, YAML.</p>
                        </li>
                        <li>
                            <p>Implemented JSON schema tests to validate API responses, increasing test coverage by approximately 20%.</p>
                        </li>
                        <li>
                            <p>Developed exhaustive tests generator to replace manual tests creation, cutting more than 90% of test duration.</p>
                        </li>
                    </ul>
                )
            }
        ]
    },
    {
        'company': 'Aalto University',
        'time': 'Apr 2021 - Jun 2021',
        'positions': [
            {
                'title': 'Teaching Assistant',
                'time': 'Apr 2021 - Jun 2021',
                'achievements': (
                    <ul>
                        <li>
                            <p><span>Technologies:</span> Python, SQL, Pandas, NumPy, seaborn, Matplotlib.</p>
                        </li>
                        <li>
                            <p>Mentored a class of over 30 B.Sc. and M.Sc. students on data analytics and data management.</p>
                        </li>
                        <li>
                            <p>Graded exercise submissions of the mentored students and host exercise solution sessions weekly.</p>
                        </li>
                        <li>
                            <p>Designed a data science project topic and template for over 50 students simulating the COVID vaccines distribution process.</p>
                        </li>
                    </ul>
                )
            }
        ]
    },
]